<!-- TracPass UI Application -->
@if (isLoading() || isLoggingOut()) {
  <app-loader [fullScreen]="true" [size]="'large'" />
} @else if (!isAuthenticated()) {
  <router-outlet />
} @else {
  <app-layout>
    <router-outlet />
  </app-layout>
}

<p-toast position="bottom-right" [life]="2000"></p-toast>
<app-confirm-popup></app-confirm-popup>
